export default function ErrorMessage({ message }){
    if(!message){
        message = "Oops, something went wrong!"
    }
    return (
        <div className="bg-red-500 text-white px-4 border rounded-md">
            {message}
        </div>
    )
}